export default __webpack_public_path__ + "static/media/info-icon.469c73fa.svg";